import { FC } from 'react';
import aboutStudioVideoMp4 from '@/assets/video/IMG_4890.mp4';
import aboutStudioVideoMov from '@/assets/video/IMG_4890.mov';

const marqueeContent = Array(8).fill('accelerate outcomes');

const AboutHero: FC = () => {
  return (
    <section className="w-full">
      <div className="relative overflow-hidden border-y border-zinc-200/70 py-10 dark:border-zinc-800/80">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white via-white/70 to-transparent dark:from-zinc-950 dark:via-zinc-950/70" aria-hidden />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white via-white/70 to-transparent dark:from-zinc-950 dark:via-zinc-950/70" aria-hidden />
        <div className="flex items-center whitespace-nowrap font-konexy text-[clamp(3.5rem,9vw,9rem)] uppercase tracking-[0.2em] text-zinc-900 animate-[marquee_16s_linear_infinite] dark:text-zinc-50">
          {marqueeContent.map((text, index) => (
            <span key={`marquee-${index}`} className="mx-14">
              {text}
            </span>
          ))}
        </div>
      </div>

      <div className="relative mt-20 w-full">
        <div className="relative overflow-hidden rounded-[24px] border border-zinc-200/70 bg-zinc-50/60 shadow-[0_25px_65px_-25px_rgba(24,24,27,0.35)] backdrop-blur-sm dark:border-zinc-800/70 dark:bg-zinc-900/60">
          <video
            className="relative block h-[420px] w-full object-cover object-center sm:h-[540px]"
            autoPlay
            loop
            muted
            playsInline
            preload="metadata"
          >
            <source src={aboutStudioVideoMp4} type="video/mp4" />
            <source src={aboutStudioVideoMov} type="video/quicktime" />
            Your browser does not support the video tag.
          </video>
          <div
            className="pointer-events-none absolute inset-0 z-10 bg-[radial-gradient(circle_at_10%_20%,rgba(250,204,21,0.22),transparent_55%),radial-gradient(circle_at_90%_15%,rgba(16,185,129,0.24),transparent_60%),radial-gradient(circle_at_15%_85%,rgba(59,130,246,0.2),transparent_60%)] dark:bg-[radial-gradient(circle_at_10%_20%,rgba(250,204,21,0.18),transparent_55%),radial-gradient(circle_at_90%_15%,rgba(16,185,129,0.2),transparent_60%),radial-gradient(circle_at_15%_85%,rgba(59,130,246,0.18),transparent_60%)]"
            aria-hidden
          />
          <div className="pointer-events-none absolute inset-0 z-20 bg-gradient-to-br from-black/40 via-transparent to-black/20 dark:from-black/65 dark:via-black/40 dark:to-black/60" aria-hidden />
          <div className="pointer-events-none absolute inset-0 z-20 backdrop-blur-[1.5px]" aria-hidden />
          <div className="pointer-events-none absolute inset-x-0 bottom-0 z-30 h-40 bg-gradient-to-b from-transparent via-black/30 to-black/70 dark:via-black/40 dark:to-black/90" aria-hidden />

          <div className="absolute inset-x-0 bottom-0 z-40 px-6 pb-6 pt-24 sm:px-8">
            <div className="text-[10px] uppercase tracking-[0.3em] text-white/75">Inside Turbo Labs</div>
            <p className="mt-3 max-w-xl font-montreal text-2xl lowercase leading-tight text-white sm:text-3xl">
              Build velocity comes from how we learn together.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
